import i18next from "i18next";

/** Texts of the page: "bidStratTesting" section of src/locales/langs/{en,fr}.json */
export const tr = (key: string, options?: Record<string, unknown>): string =>
    i18next.t(`bidStratTesting.${key}`, options) as string;

export const monthNames = (): string[] => i18next.t("bidStratTesting.months", { returnObjects: true }) as string[];
